import { useGenericModal } from "../components/GenericModal";
import { findApiErrorMessage } from "../utils/utils";

export function useGenericErrorModal() {
  const errorModal = useGenericModal();

  const fireErrorModal = (error: any) => {
    const errorMessage =
      typeof error === "string" ? error : findApiErrorMessage(error);
    errorModal.set({
      isOpen: true,
      hideTitleIcon: true,
      title: "Error",
      description: errorMessage,
      isConfirmButtonHidden: true,
      onClickClose: async () => errorModal.reset(),
    });
  };

  return {
    ...errorModal,
    fireErrorModal,
  };
}
